import React from 'react'
import { Section, Link, Image, PostDetails, CategoryList } from 'newComponents'
import truncateString from '../../../utils/truncateString'
import stars from '../../../images/static-stars.jpg'
import './styles.scss'

const FeatureBlock = ({ title, posts, post }) => {
  const columnVariant = post && !posts ? 'one-post' : 'two-posts'
  if (!columnVariant) return null
  if (!posts && !post) return null

  return (
    <Section className={`feature-block ${columnVariant}`}>
      {title && <span className="feature-block-title">{title}</span>}
      {/* TWO COL VARIANT */}
      {columnVariant === 'two-posts' && posts && (
        <div className="feature-block-grid">
          {posts.map((item) => {
            const { category, title: postTitle, image, url } = item
            return (
              <div className="feature-block-post" key={postTitle}>
                <Link to={`${url}`} className="feature-block-img-link">
                  <Image className="feature-block-post-img" image={image?.localFile || image?.url || stars} />
                </Link>
                <Link to={`${url}`} className="feature-block-post-category">
                  {category}
                </Link>
                <Link to={`${url}`} className="feature-block-post-title">
                  {postTitle}
                </Link>
              </div>
            )
          })}
        </div>
      )}
      {/* ONE COL VARIANT */}
      {columnVariant === 'one-post' && (
        <div className="feature-block-container">
          {post.map((postData) => {
            const { uid: slug, data, dataString } = postData
            const {
              author,
              categories,
              excerpt,
              featured_image: featuredImage,
              timestamp,
              title: postTitle,
              body
            } = data

            // data formatting
            const { primary } = body[0]
            const { wysiwyg } = primary
            const { text } = wysiwyg
            const excerptBackup = truncateString(text, 250)

            return (
              <div className="feature-block-post" key={postTitle.text}>
                <div className="feature-block-text">
                  <CategoryList categories={categories} />
                  {postTitle && (
                    <Link to={`/blog/${slug}`} className="feature-block-title">
                      <span>{postTitle.text}</span>
                    </Link>
                  )}
                  <span className="feature-block-excerpt">{excerpt.text || excerptBackup}</span>
                  <PostDetails author={author} timestamp={timestamp} dataString={dataString} />
                </div>
                <Link to={`/blog/${slug}`} className="feature-block-img-link">
                  <Image className="feature-block-image" image={featuredImage || stars} />
                </Link>
              </div>
            )
          })}
        </div>
      )}
    </Section>
  )
}

export default FeatureBlock
